(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["naonx-style-gallery"] && !Shopify.designMode) return;
  try {
    
  /*
    The Style Gallery masonry: lays its items (filled in by the NAONX app) out
    in columns, each in turn under the shortest one, so the order reads left
    to right and a further page only adds below. Photos carry their size, so
    they are placed before they load; the layout is redone when the width
    changes, items come or go, or a photo turns out another shape.
  */
  if (!customElements.get('naonx-gallery-masonry')) {
    customElements.define('naonx-gallery-masonry', class extends HTMLElement {
      connectedCallback() {
        this.width = 0;
        this.items = new MutationObserver(() => this.layout());
        this.items.observe(this, { childList: true });
        this.resize = new ResizeObserver(() => {
          if (this.clientWidth !== this.width) this.layout();
        });
        this.resize.observe(this);
        this.addEventListener('load', this.loaded, true);
        this.layout();
      }

      disconnectedCallback() {
        this.items.disconnect();
        this.resize.disconnect();
        this.removeEventListener('load', this.loaded, true);
      }

      loaded = (event) => {
        if (!(event.target instanceof HTMLImageElement)) return;
        event.target.setAttribute('data-loaded', '');
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.layout();
        });
      };

      layout() {
        const style = getComputedStyle(this);
        const gap = parseFloat(style.columnGap) || 0;
        const wanted = parseFloat(style.getPropertyValue('--naonx-gallery-image-width')) || 200;
        this.width = this.clientWidth;
        const count = parseInt(style.getPropertyValue('--naonx-gallery-columns'), 10)
          || Math.max(1, Math.floor((this.width + gap) / (wanted + gap)));
        const width = (this.width - gap * (count - 1)) / count;
        this.style.setProperty('--naonx-gallery-column-width', `${width}px`);
        const items = [...this.children];
        const heights = items.map((item) => item.offsetHeight);
        const columns = new Array(count).fill(0);
        items.forEach((item, index) => {
          const column = columns.indexOf(Math.min(...columns));
          item.style.transform = `translate(${column * (width + gap)}px, ${columns[column]}px)`;
          columns[column] += heights[index] + gap;
        });
        this.style.height = `${Math.max(0, Math.max(...columns) - gap)}px`;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
